<template>
  <div>
    <div id="Chart2" style="width: 100%; height: 320px"></div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  props:{
    chart2_data_x:{
      type:Array,
      default(){
        return []
      }
    },
    chart2_data_y:{
      type:Array,
      default(){
        return []
      }
    },
    chart2_data_y2:{
      type:Array,
      default(){
        return []
      }
    },
    chart2_data_y3:{
      type:Array,
      default(){
        return []
      }
    },
    chart2_data_y4:{
      type:Array,
      default(){
        return []
      }
    },
  },
  methods: {
    myEcharts2() {
      var myChart2 = this.$echarts.init(document.getElementById("Chart2"));
      //配置图表
      var option2 = {
        tooltip: {
          trigger: "axis",
        },
        grid: {
          containLabel: true,
          left: 0,
          right: 0,
          bottom: 25,
          top: 30,
        },
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: this.chart2_data_x,
          axisTick: {
            show: false,
          },
          axisLine: {
            show: false,
          },
          offset: 24,
          axisLabel: {
            formatter: function (value,index) {
              return `${value}`
            },
            rich: {
              a: {
                width: 140,
                align: "right",
              },
              b: {
                width: 140,
                align: "left",
              },
            },
          },
        },
        yAxis: [
          {
            type: "value",
            axisLabel: {
              textStyle: {
                color: function (e) {
                  if (e > 50) {
                    return "#fd4c4c";
                  } else {
                    return "#fcad2a";
                  }
                },
              },
              formatter: function (value) {
                return value;
              },
            },
            position: "left",
          },
        ],
        series: [
          {
            name: "中估",
            type: "line",
            smooth: true,
            symbol: "none",
            color: "#fcad2a",
            data: this.chart2_data_y3,
          },
          {
            name: "高估",
            type: "line",
            smooth: true,
            symbol: "none",
            color: "#fd4c4c",
            data: this.chart2_data_y4,
          },
          {
            name: "低估",
            type: "line",
            smooth: true,
            symbol: "none",
            color: "#3cbb73",
            data: this.chart2_data_y2,
          },
          {
            name: "不知道是啥",
            type: "line",
            smooth: true,
            symbol: "none",
            color: "#539cff",
            data: this.chart2_data_y,
            areaStyle: {
              color: {
                type: "linear",
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [
                  {
                    offset: 0,
                    color: "rgba(83,156,255,.24)", // 0% 处的颜色
                  },
                  {
                    offset: 1,
                    color: "rgba(83,156,255,0)", // 100% 处的颜色
                  },
                ],
                global: false, // 缺省为 false
              },
            },
          },
        ],
      };
      myChart2.setOption(option2);
    },
  },
  mounted() {
    // this.myEcharts2();
  },
};
</script>

<style scoped>
</style>